import repository from "../Repository";

export default {
  async facilitiesList(screenId, facility_class) {
    return await repository.post(
      "facilities",
      {
        facility_class
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async list(screenId, municip_code) {
    return await repository.post(
      "autonomy_info",
      {
        municip_code
      },
      {
        headers: {
          s: screenId
        }
      }
    );
  },
  async create(screenId, payload) {
    return await repository.post("autonomy_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async update(screenId, payload) {
    return await repository.patch("autonomy_ope", payload, {
      headers: {
        s: screenId
      }
    });
  },
  async delete(screenId, payload) {
    return await repository.patch(
      "autonomy_ope/delete",
      payload,
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
